export default "/images/visa24x24.svg?ad13f8be989e7f1c0a573a6795eb1e7a";